module.exports = __webpack_public_path__ + "img/product.30ab482f.svg";